import { Text, TextProps } from '@chakra-ui/react'
import React from 'react'

export { Text }
export type { TextProps }

export const Headline = (props: TextProps) => (
  <Text as="h1" textStyle="headline" {...props} />
)

export const Heading = (props: TextProps) => (
  <Text as="h2" maxWidth="prose" textStyle="heading" {...props} />
)

export const SubHeadline = (props: TextProps) => (
  <Text as="h3" maxWidth="prose" textStyle="subHeadline" {...props} />
)
export const SubHeading = (props: TextProps) => (
  <Text as="h3" maxWidth="prose" textStyle="subHeading" {...props} />
)

export const Body = (props: TextProps) => (
  <Text maxWidth="article" textStyle="body" {...props} />
)

export const Detail = (props: TextProps) => (
  <Text textStyle="detail" {...props} />
)

export const Cta = React.forwardRef<HTMLParagraphElement, TextProps>(
  (props, ref) => <Text cursor="pointer" textStyle="cta" {...props} ref={ref} />
)

export const Quote = ({
  children,
  author,
  ...props
}: TextProps & { author: string }) => (
  <Text maxWidth="prose" textStyle="quote" as="h3" {...props}>
    {children}
    <Text textStyle="body" size="md" mt="md">
      {author}
    </Text>
  </Text>
)
